import { render, staticRenderFns } from "./VolumeClaimTemplate.vue?vue&type=template&id=cb3561ea&scoped=true&"
import script from "./VolumeClaimTemplate.vue?vue&type=script&lang=js&"
export * from "./VolumeClaimTemplate.vue?vue&type=script&lang=js&"
import style0 from "./VolumeClaimTemplate.vue?vue&type=style&index=0&id=cb3561ea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb3561ea",
  null
  
)

export default component.exports